// extracted by mini-css-extract-plugin
module.exports = {"shoppingListContainer":"addToShoppingList_shoppingListContainer__peUdu","saveForLater":"addToShoppingList_saveForLater__YuLaN"};